<template class="">
 <!-- Navigation Header -->
 <header class="navbar " :class="{ 'scrolled': isScrolled }">
   <div class="container plus_x20">
     <div class="navbar-content">
       <!-- Logo -->
       <div class="logo">
        <router-link :to="{ name: 'homepage' }">
         <img src="@/assets/imgs/web/weblogo.png" alt="AlUla Logo" />
        </router-link>
       </div>

       <!-- Hamburger Menu -->
        <div class="nav-controls">
          <div class="g_nm vm">
            <button class="hamburger" @click="toggleMenu" :class="{ 'active': menuOpen }">
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
       <!-- Switch Language button (Mobile) -->
          <div class="g_nm vm">
            <svg @click="changeLang()" class="vm" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><g fill="none" stroke="#fff" stroke-width="2"><path d="M22 12a10 10 0 1 1-20.001 0A10 10 0 0 1 22 12Z"/><path d="M16 12c0 1.313-.104 2.614-.305 3.827c-.2 1.213-.495 2.315-.867 3.244c-.371.929-.812 1.665-1.297 2.168c-.486.502-1.006.761-1.531.761s-1.045-.259-1.53-.761c-.486-.503-.927-1.24-1.298-2.168c-.372-.929-.667-2.03-.868-3.244A23.6 23.6 0 0 1 8 12c0-1.313.103-2.614.304-3.827s.496-2.315.868-3.244c.371-.929.812-1.665 1.297-2.168C10.955 2.26 11.475 2 12 2s1.045.259 1.53.761c.486.503.927 1.24 1.298 2.168c.372.929.667 2.03.867 3.244C15.897 9.386 16 10.687 16 12Z"/><path stroke-linecap="round" d="M2 12h20"/></g></svg>
           </div>
        </div>
       <!-- Navigation Menu -->
       <nav class="nav-menu" :class="{ 'active': menuOpen }">
         <router-link v-for="el in link_list"  :to="{ path: el.navigation_route }" class="nav-link" :class="{ 'active': $route.path == el.navigation_route }" @click="closeMenu">{{ $i18n.locale=='en' ? el.title_en : el.title_ar }}</router-link> 
         <router-link  :to="{ name: 'contactpage' }" class="nav-link" :class="{ 'active': $route.name === 'contactpage' }" @click="closeMenu"><button class="nav-cta-btn mobile-cta" @click="closeMenu">{{ $t('Get in touch') }}</button></router-link>
       </nav>
       <div class="sdeskhmd">
       <!-- CTA Button (Desktop) -->
       <router-link :to="{ name: 'contactpage' }" class="nav-cta-btn desktop-cta">{{ $t('Get in touch') }}</router-link>
       <!-- Switch Language button (Desktop) -->
        <div class="nav-cta-btn lang-btn" @click="changeLang()">
          <svg class="vm" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><g fill="none" stroke="#fff" stroke-width="1"><path d="M22 12a10 10 0 1 1-20.001 0A10 10 0 0 1 22 12Z"/><path d="M16 12c0 1.313-.104 2.614-.305 3.827c-.2 1.213-.495 2.315-.867 3.244c-.371.929-.812 1.665-1.297 2.168c-.486.502-1.006.761-1.531.761s-1.045-.259-1.53-.761c-.486-.503-.927-1.24-1.298-2.168c-.372-.929-.667-2.03-.868-3.244A23.6 23.6 0 0 1 8 12c0-1.313.103-2.614.304-3.827s.496-2.315.868-3.244c.371-.929.812-1.665 1.297-2.168C10.955 2.26 11.475 2 12 2s1.045.259 1.53.761c.486.503.927 1.24 1.298 2.168c.372.929.667 2.03.867 3.244C15.897 9.386 16 10.687 16 12Z"/><path stroke-linecap="round" d="M2 12h20"/></g></svg>
          <span class="vm ml5">
            {{ $i18n.locale=='en' ? 'AR' : 'EN' }}
          </span>
       </div>
       </div>
       
     </div>
   </div>
 </header>
<div style="min-height: 100vh;">
 <router-view ></router-view>
</div>
 <Footer :link_list="link_list" />
 <div class="pf ov bgb10 " v-if="$store.state.loader==1" style="z-index: 9999999;">
     <div class="cc c">
      <span class="mainloader"></span>
     </div>
  </div>
  <div class="pf ov bgb10 " v-if="$store.state.showPopUp" style="z-index: 9999999;">
    <div class="cc w90 popUp oya c" >
      <div v-if="$store.state.apiStatus==true">
        <img src="@/assets/imgs/reg/check.svg" alt="" class="w100" style="width: 100px;">
      </div>
      <div v-if="$store.state.apiStatus==false">
        <!-- <img src="@/assets/imgs/reg/cross.svg" alt="" class="w100" style="width: 100px;"> -->
      </div>
      <p class="c-brown-dark mt25 fs20">{{ $store.state.popUpMessage }}</p>
      <div class="c mt15">
        <div v-if="$store.state.apiStatus==false" class="g_nm w100 goBackButton mt30" @click="close(0)" style="max-width: 200px;">Ok</div>
        <div v-if="$store.state.apiStatus==true" class="g_nm w100 goBackButton mt30" @click="close(1)" style="max-width: 200px;">Ok</div>
      </div>
    </div>
  </div>
</template>
<script>
import Footer from '@/components/Common/Footer.vue';
  export default {
    data(){
      return{
        menuOpen: false,
        isScrolled: false
      }
    },
    components: {
      Footer
    },
    name: "WebLayout",
    created(){
      this.axios.get(this.$store.state.baseApiUrl+'web-content/get-navigation').then((response)=>{
        this.link_list=response.data.data;
      }).catch((error)=>{
        console.log(error);
      });
    },

    mounted() {
      window.addEventListener('scroll', this.handleScroll)
      const expiretime = 7 * 24 * 60 * 60 * 1000; // days
      const cookiesLang = this.$cookies.get('lang');
      if (cookiesLang) {
        this.$i18n.locale = cookiesLang;
        if(cookiesLang=='ar'){
          $('body').addClass('rtl');
          $('html').attr('lang','ar');
        }
        else{
          $('body').removeClass('rtl');
          $('html').attr('lang','en');
        }
      } else {
        this.$cookies.set('lang', this.$i18n.locale, expiretime);
      }
    },
    
    beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods:{
      enarSpaceDash(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        // Allow English letters, Arabic letters, spaces, and -
        const regex = /^[a-zA-Z\u0600-\u06FF\s-]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only English and Arabic letters, spaces and - are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      
      validatedata(formname, errorClass, text) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        if (formname == "" || formname == null ) {
          $(errorDiv).html(text);
          $(errorDiv).slideDown();
          $(errorInput).addClass('error');
          return 0;
        } else {
          $(errorInput).removeClass('error');
          $(errorDiv).slideUp();
          return 1;
        }
      },
      allowedEmailChar(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /^[a-zA-Z0-9@._+\-]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only english letters, numbers and @ . _ - are allowed in email.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      changeLang(){
        if(this.$i18n.locale=='en'){
          this.$i18n.locale='ar';
          $('body').addClass('rtl');
          $('html').attr('lang','ar');
          const expiretime = 7 * 24 * 60 * 60 * 1000; // days
          this.$cookies.set('lang', 'ar', expiretime);
        }
        else{
          this.$i18n.locale='en';
          $('body').removeClass('rtl');
          $('html').attr('lang','en');
          const expiretime = 7 * 24 * 60 * 60 * 1000; // days
          this.$cookies.set('lang', 'en', expiretime);
        }
      },
      close(stauts){
        if(stauts==0){
          this.$store.state.showPopUp=false;
        }
        else{
          this.$store.state.showPopUp=false;
          this.$router.push({ name: 'homepage' });
        }
      },
      toggleMenu() {
        this.menuOpen = !this.menuOpen
        if (this.menuOpen) {
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = ''
        }
      },
      closeMenu() {
        this.menuOpen = false
        document.body.style.overflow = ''
      },
      handleScroll() {
        this.isScrolled = window.scrollY > 50
      }
    },
    provide() {
      return {
        validatedata: this.validatedata,
        enarSpaceDash: this.enarSpaceDash,
        allowedEmailChar: this.allowedEmailChar,
      };
    }
  }
</script>

<style scoped>
/* Global Overflow Fix */
:global(body) {
  overflow-x: hidden;
  max-width: 100vw;
}

/* Navbar Styles */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 20px 0;
  transition: all 0.3s ease;
  /* background: rgba(63, 36, 22, 0.3);
  backdrop-filter: blur(10px); */
}

.navbar.scrolled {
  /* background: rgba(63, 36, 22, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 0; */
}
.navbar.scrolled .navbar-content {
  background: rgba(63, 36, 22, 0.5);
}

/* .navbar .container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 60px;
  width: 100%;
} */

.navbar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* background: rgba(255, 255, 255, 0.1); */
  background: rgba(63, 36, 22, 0.4);

  border-radius: 200px;
  padding: 15px 50px;
  backdrop-filter: blur(16px);
}

.logo img {
  height: 50px;
  width: auto;
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 35px;
}

.nav-link {
  color: #ffffff;
  text-decoration: none;
  font-size: 16px;
  text-align: center;
  font-weight: 400;
  transition: opacity 0.3s ease;
  letter-spacing: 0.3px;
}
.nav-link.active {
  font-weight: 600;
  text-decoration: underline;
}
.nav-link:hover {
  opacity: 0.8;
}

.nav-cta-btn {
  background: #8B5A3C;
  color: #ffffff;
  border: none;
  padding: 10px 15px;
  border-radius: 30px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.lang-btn{
  padding: 10px 12px;
  height: 42px;
}

.nav-cta-btn:hover {
  background: #6d4530;
  transform: translateY(-2px);
}

.hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  z-index: 1001;
}

.hamburger span {
  width: 25px;
  height: 3px;
  background: #ffffff;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.hamburger.active span:nth-child(1) {
  transform: rotate(45deg) translate(8px, 8px);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -7px);
}

.mobile-cta {
  display: none;
}

.desktop-cta {
  display: block;
}
@media (max-width: 1280px) {
  .navbar-content{
    padding: 12px 25px;
  }
  .nav-menu{
    gap: 20px;
  }
  
}
.nav-controls{
  display: none;
}
/* Responsive Navbar */
@media (max-width: 1100px) {
  .nav-controls{
    display: inline-block;
  }
  .navbar ,.navbar.scrolled {
    background: rgba(63, 36, 22, 1);
    padding: 15px 0;
  }
   .hamburger {
    display: flex;
  }

  /* .navbar .container {
    padding: 0 40px;
  } */

  .navbar-content {
    /* padding: 12px 30px; */
    background: rgba(255, 255, 255, 0.08);
  }

  

  .desktop-cta {
    display: none;
  }

  .nav-menu {
    position: fixed;
    top: 0;
    right: -100%;
    width: 100%;
    height: 100vh;
    background: #3F2416;
    flex-direction: column;
    padding: 80px 20px 20px;
    gap: 15px;
    transition: right 0.3s ease;
    overflow-y: auto;
    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.3);
    visibility: hidden;
  }

  .nav-menu.active {
    right: 0;
    visibility: visible;
  }

  .nav-link {
    width: 100%;
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 15px;
  }

  .mobile-cta {
    display: block;
    width: 100%;
    margin-top: 15px;
    padding: 12px 24px;
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  /* .navbar .container {
    padding: 0 15px;
  } */

  .navbar-content {
    padding: 10px 20px;
    border-radius: 100px;
  }

  .logo img {
    height: 40px;
  }

  .nav-link {
    padding: 8px 0;
    font-size: 14px;
  }

  .mobile-cta {
    padding: 10px 20px;
    font-size: 14px;
    margin-top: 10px;
  }
}
.sdeskhmd{
  display: flex;
  gap: 5px;
  align-items: center;
}
@media (max-width: 1100px) {
  .sdeskhmd{
    display: none;
  }
  .navbar {
    background: rgba(63, 36, 22, 0.95);
    padding: 15px 0;
  }

  /* .navbar .container {
    padding: 0 40px;
  } */

  .navbar-content {
    padding: 12px 30px;
    background: rgba(255, 255, 255, 0.08);
  }

  .logo img {
    height: 35px;
  }

  .nav-menu {
    width: 100%;
    right: -100%;
  }

  .hamburger span {
    width: 22px;
  }
}


</style>